import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseMessageStatus } from '../shared/enums';
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  //#region properties
  isSpinning = false;
  tooltipColor: string = '#326C96';

  incompleteStatusCountObserver: BehaviorSubject<any> =
    new BehaviorSubject<any>(null);
  incompleteStatusRecords: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  //#endregion

  //#region common methods
  /**
   * Use this common method for all the GET api
   * @param Url Just pass url after /api/. Predefine url will take from environment.
   * @param isLoader If you dont want to display loader in any API call send FALSE.
   * @param Options Set any other options if required.
   * @returns
   */
  API_GET(
    Url: string,
    isLoader: Boolean = true,
    Options?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .get<any>(
        //`${Url}`,
        `${environment.apiURL}${Url}`,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.changeDetection.detectChanges();
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  /** Post API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   * @param Body - Pass body parameter in json. Ex : { id : 1, name : Sushma, occupation : Angular Developer}
   */
  API_POST(
    Url: string,
    Body?: object,
    isLoader: Boolean = true,
    Options?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .post<any>(
        `${environment.apiURL}${Url}`,
        Body,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  /** Delete API Method.
   * @param Url - Just pass url after /api/. Predefine url will take from environment
   */
  API_DELETE(
    Url: string,
    isLoader: Boolean = true,
    Options?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .delete<any>(
        `${environment.apiURL}${Url}`,
        Options ? Options : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          //this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }

  // API_PUT(
  //   Url: string,
  //   isLoader: Boolean = true,
  //   Options?: any
  // ): Observable<any> {
  //   let hd = this.GetHeader();
  //   console.log('getTokenObj', hd);
  //   if (isLoader) {
  //     this.isSpinning = true;
  //     // this.displayLoader(true);
  //   }
  //   return this._httpClient
  //     .put<any>(
  //       `${environment.apiURL}${Url}`,
  //       Options ? Options : { headers: hd }
  //     )
  //     .pipe(
  //       map((data) => {
  //         console.log('data', data);
  //         this.isSpinning = false;
  //         // this.displayLoader(false);
  //         return data;
  //       }),
  //       catchError((err) => {
  //         this.isSpinning = false;
  //         // this.displayLoader(false);
  //         this.errorHandling(err, Url);
  //         return throwError(err);
  //       })
  //     );
  // }
  API_PUT(
    Url: any,
    Body: any,
    isLoader: Boolean = true,
    Options?: any,
    responseType?: any
  ): Observable<any> {
    let hd = this.GetHeader();
    if (isLoader) {
      this.isSpinning = true;
      // this.displayLoader(true);
    }
    return this._httpClient
      .put<any>(
        `${environment.apiURL}${Url}`,
        Body,
        responseType
          ? { headers: hd, responseType: responseType }
          : Options
          ? Options
          : { headers: hd }
      )
      .pipe(
        map((data) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          return data;
        }),
        catchError((err) => {
          this.isSpinning = false;
          // this.displayLoader(false);
          this.errorHandling(err, Url);
          return throwError(err);
        })
      );
  }
  /**
   * get the request header to pass in apis
   * @returns headers
   */
  GetHeader() {
    const tokenObj = this.getTokenObj();
    // const tenantObj = this.getTenantObj();
    var headers: HttpHeaders = new HttpHeaders();
    // headers = headers.set('Content-Type', 'application/json');
    headers = headers.set('Access-Control-Allow-Origin', '*');
    if (tokenObj) {
      headers = headers.set('authorization', 'Bearer ' + tokenObj);
    } else {
      return;
    }
    return headers;
  }

  /**
   * get only authoraztion token in header request
   */
  GetAuthorizationHeader() {
    const tokenObj = this.getTokenObj();
    var headers: HttpHeaders = new HttpHeaders();
    // headers = headers.set('Content-Type', 'multipart/form-data');
    // headers = headers.set("Access-Control-Allow-Origin", '*');
    headers = headers.set('Accept', '*/*');
    if (tokenObj) {
      headers = headers.set('authorization', 'Bearer ' + tokenObj);
    } else {
      return;
    }
    return headers;
  }

  /**
   * get token object function
   */
  getTokenObj() {
    var localtoken = localStorage.getItem('BrearToken');
    if (localtoken) {
      return localtoken;
    } else {
      return null;
    }
  }

  /**
   * @param err pass here error  for handle by status
   */
  errorHandling(err: any, URL: string) {
    if (
      (err.status == 401 || err.status == 400 || err.status == 0) &&
      URL.includes('Login')
    ) {
      this.displayMessage(
        ResponseMessageStatus.error,
        'Please enter valid login details.'
      );
    } else if (err.status != 401) {
      this._router.navigate(['/error'], {
        queryParams: {
          status: err.status,
          statusText: err.statusText,
          message: err.message,
        },
      });
    } else {
      this._router.navigate(['/login']);
      this.logOut();
      this.displayLoader(false);
    }
  }

  displayMessage(type: string, message: string) {
    this._message.create(type.toString(), message);
  }

  displayLoader(value: boolean) {
    value
      ? this._spinner.show(undefined, {
          type: 'ball-pulse',
          size: 'small',
          bdColor: 'rgb(0,0,0,0.2)',
          color: '#00000',
          fullScreen: true,
        })
      : this._spinner.hide();
  }

  /**
   * Call this below method before clicking the save button, to mark all form feilds as touched, helps in validation.
   * @param formGroup Pass the formgroup name here to mark all feilds as touched.
   */
  markFormGroupTouched(formGroup: FormGroup) {
    // Object.values(formGroup.controls).forEach(control => {
    //   control.markAsTouched();
    // });
    Object.values(formGroup.controls).forEach((control) => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
  }

  /**
   * Use this method to set local storage items
   * @param key key of the local storage item we want save
   * @param value value of the local storage item we want save
   */
  setLocalStorageItem(key: string, value: any) {
    if (value != null && value != undefined) {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, '');
    }
  }

  /**
   * @param key Name of localstorage name
   * @returns returns localstorage item
   */
  getLocalStorageItem(key: string) {
    return localStorage.getItem(key);
  }

  /**
   * Set logged in user and his/her Group in global object.
   */
  getUserObj() {
    var loggedInUser = this.getLocalStorageItem('userInfo');
    return loggedInUser;
  }

  /**
   * Common Logout function
   */
  logOut() {
    // localStorage.clear();
    localStorage.removeItem('BrearToken');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('dashboard_data');
    localStorage.removeItem('stock_data');
    localStorage.removeItem('assignment_data');
    localStorage.removeItem('status_data');
  }

   //base64 to url for pdf-viewer
   base64ToURL(base64: any) {
    const byteArray = new Uint8Array(
      atob(base64)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    const file = new Blob([byteArray], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    return fileURL;
  }

  /**
   * prevent number key on key down function
   * @param event pass event ok key press
   */
  validateNumber(event: any, isAllowNegetive = false) {
    const keyCode = event.keyCode;
    var excludedKeys = [];
    if (!isAllowNegetive) {
      excludedKeys = [8, 9, 37, 39];
    } else {
      excludedKeys = [8, 9, 37, 39, 45];
    }
    if (
      !(
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        excludedKeys.includes(keyCode)
      )
    ) {
      event.preventDefault();
    }
  }

  formatDate = (date: any) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  };

  lst_StockLocation: any = [
    { id: 1, value: 'In Production' },
    { id: 2, value: 'On Water' },
    { id: 3, value: 'In Warehouse' },
  ];

  //#endregion

  constructor(
    private _message: NzMessageService,
    private _spinner: NgxSpinnerService,
    private _httpClient: HttpClient,
    private _router: Router
  ) {}
}
